const routes = [
    {
        path: '/checkins/inscricoes',
        name: 'Inscricoes',
        component: () => import('./Form.vue'),
    },
    {
        path: '/checkins/inscricoes/atendimento',
        name: 'InscricoesAtendimento',
        component: () => import('./Form.vue'),
        meta: {
            rules: ['CHECKINS-INSCRICOES-02'],
        },
    },
    {
        path: '/checkins/inscricoes/totem',
        name: 'InscricoesTotem',
        component: () => import('./FormTotem.vue'),
    },
];

export default routes;
